import React, { memo } from 'react'
import { Trans } from 'react-i18next'

import ExternalLink from '../text/ExternalLink'

const TermsPolicies = ({ i18nKey, links }) => {
  return (
    <Trans i18nKey={i18nKey} i18nIsDynamicList>
      {links.map(({ label, to }, index) => {
        return (
          <ExternalLink key={index} label={label} to={to} fontWeight='bold' />
        )
      })}
    </Trans>
  )
}

export default memo(TermsPolicies)
